module.exports = __webpack_public_path__ + "img/2.82c078c3.png";